import { useQuery } from '@apollo/client';
import type { ApolloError } from '@apollo/client';

import { GetPayByBankSignupOfferDocument } from 'src/gql/graphql';
import type { GetPayByBankSignupOfferQuery } from 'src/gql/graphql';
import { toUppercaseMenuType } from 'shared/constants';

type Offer = NonNullable<GetPayByBankSignupOfferQuery['getPayByBankSignupOffer']>['payByBankSignupIncentive'];

export function usePayByBankSignupOffer({
  dispensaryId,
  menuType,
  enabled,
}: {
  dispensaryId?: string;
  menuType: string;
  enabled: boolean;
}): { offer: Offer | undefined; error: ApolloError | undefined } {
  const { data, error } = useQuery(GetPayByBankSignupOfferDocument, {
    variables: { dispensaryId: dispensaryId ?? '', menuType: toUppercaseMenuType(menuType) },
    skip: !enabled || !dispensaryId,
  });

  return { offer: data?.getPayByBankSignupOffer?.payByBankSignupIncentive, error };
}
